import type { SVGProps } from "react";

export function IconWhite3Packages(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M32 32V57M32 32H44.5M32 32H19.5M32 57H57V32H44.5M32 57H7V32H19.5M44.5 32V38M44.5 32V7H32M44.5 32H19.5M19.5 32V7H32M19.5 32V38M32 7V13"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
